import React, { HTMLAttributes, } from "react";

type SizeBoxProps = HTMLAttributes<HTMLDivElement> & {
  width?: number;
  height?: number;
  className?: string;
}

export default function SizedBox(props: SizeBoxProps): JSX.Element {
  return (
    <div
      {...props}
      style={{
        width: props.width && String(props.width).concat("rem"),
        height: props.height && String(props.height).concat("rem"),
        flexShrink: 0
      }}
    />
  );
}